import Accordion from "./modules/accordion";

function handleNavigation() {
    // Toggle the mega menu
    jQuery('#main-menu > li:not(.btn) > a').on('click', function (e) {
        e.preventDefault();
        jQuery(this).parent('li').siblings('li').find('.mega-submenu').removeClass('open');
        jQuery(this).parent('li').find('.mega-submenu').toggleClass('open');
        jQuery(this).parent('li').siblings('li').removeClass('active');
        jQuery('.search-wrap').removeClass('active');
    })

    jQuery('#main-menu > li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        jQuery(this).parent('li').toggleClass('active');
    })

    // Close mega menu on click outside of #main-menu
    jQuery(document).on('click', function (e) {
        if (!jQuery(e.target).closest('#main-menu').length) {
            jQuery('.mega-submenu').removeClass('open');
            jQuery('.menu-item-has-children').removeClass('active');
        }
    });
}

function handleSidebarDropdowns() {
    const handles = document.querySelectorAll('#left-sidebar .menu-item-has-children>a');

    handles.forEach(function (handle) {
        handle.addEventListener('click', function (event) {
            event.preventDefault();
            if (handle.parentElement.classList.contains('expanded')) {
                handle.parentElement.classList.remove('expanded');
            } else {
                handle.parentElement.classList.add('expanded');
            }
        });
    });
}

function handleCarousels() {
    jQuery(".slick-carousel-container").each(function () {
        jQuery(this).slick({
            infinite: true,
            autoplay: true,
            speed: 800,
            slidesToShow: 3,
            gap: 20,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
            ]
        })
    });
}

function initAccordions() {
    const accordions = document.querySelectorAll('.accordions-container button');
    accordions.forEach(function (accordion) {
        new Accordion(accordion)
    });
}

function initBreadcrumbMenu() {
    const breadcrumbs = document.getElementById('breadcrumbs');
    breadcrumbs.addEventListener('click', handleBreadcrumbMenu);
}

function handleBreadcrumbMenu(event) {
    // Only run if on mobile
    if (window.innerWidth > 992) {
        return;
    }

    const breadcrumbMenu = document.getElementById('left-sidebar');
    if (breadcrumbMenu) {
        breadcrumbMenu.classList.toggle("active");
    }
}


jQuery(document).ready(function () {
    handleNavigation();
    handleSidebarDropdowns();
    handleCarousels();
    initAccordions();
    initBreadcrumbMenu();
});